import React, { lazy, Suspense } from 'react'
import { useTranslation } from 'react-i18next'

const Index = () => {
  const { t } = useTranslation()
  const Conections = lazy(
    () => import('../../components/principalContent/connections')
  )
  const ServicesTabs = lazy(
    () => import('../../components/principalContent/servicesTabs')
  )
  const ServicesCards = lazy(
    () => import('../../components/principalContent/servicesCards')
  )
  const Benefits = lazy(
    () => import('../../components/principalContent/benefits')
  )

  return (
    <>
      <div className={`container-index`}>
        <Suspense fallback={<div>{`${t('LOADING')}`}</div>}>
          <div id="connections">
            <Conections />
          </div>
          <div id="services">
            <ServicesTabs />
          </div>
          <div id="plans">
            <ServicesCards cardsOptions={[]} />
          </div>
          <div id="benefits">
            <Benefits />
          </div>
        </Suspense>
      </div>
    </>
  )
}

export default Index
